import React from "react";
import { NavLink } from "react-router-dom";
import { Menu, Icon } from "semantic-ui-react";

import logoUrl from "../images/logo.png";

const Header = (props) => (
  <React.Fragment>
    {window.innerWidth <= 1024 ? null : (
      <Menu.Item>
        <img src="https://atwood-assets.s3.us-east-2.amazonaws.com/awr-logo.png" />
      </Menu.Item>
    )}
    <Menu.Item exact activeClassName="link-active" as={NavLink} to="/dealer/">
      Home
    </Menu.Item>
    <Menu.Item activeClassName="link-active" as={NavLink} to="/dealer/profile">
      Profile
    </Menu.Item>
    {props.verified ? (
      <React.Fragment>
        <Menu.Item
          activeClassName="link-active"
          as={NavLink}
          to="/dealer/systems"
        >
          Systems
        </Menu.Item>
        <Menu.Item
          activeClassName="link-active"
          as={NavLink}
          to="/dealer/contracts"
        >
          Contracts
        </Menu.Item>
        <Menu.Item
          activeClassName="link-active"
          as={NavLink}
          to="/dealer/salespeople"
        >
          Salespeople
        </Menu.Item>
        <Menu.Item
          activeClassName="link-active"
          as={NavLink}
          to="/dealer/marketing"
        >
          Marketing
        </Menu.Item>
      </React.Fragment>
    ) : null}
    <Menu.Item
      position="right"
      exact
      to="#"
      onClick={props.onLogout}
      as={NavLink}
    >
      Logout
    </Menu.Item>
  </React.Fragment>
);

// const Header = props => (
//   <div className="ui left vertical visible sidebar menu">
//     <NavLink exact activeClassName="link-active" className="item" to="/dealer/">Home</NavLink>
//     <NavLink activeClassName="link-active" className="item" to="/dealer/profile">Profile</NavLink>
//     <NavLink activeClassName="link-active" className="item" to="/dealer/systems">Systems</NavLink>
//     <NavLink activeClassName="link-active" className="item" to="/dealer/contracts">Contracts</NavLink>
//     <NavLink activeClassName="link-active" className="item" to="/dealer/salespeople">Salespeople</NavLink>
//     <NavLink exact activeClassName="link-active" className="ui item" to="#" onClick={props.onLogout}>Logout</NavLink>
//   </div>
// );

export default Header;
